import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IFormsState = {
    isFormsLoaded: false,
    forms: []
};

export const reducer = produce((draftState, action: Types.TFormsAction): Types.IFormsState | void => {
    switch (action.type) {
        case actionTypes.UPDATE_FORMS_DATA: {
            Object.assign(draftState, {
                forms: action.payload,
                isFormsLoaded: true
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
